import { ArrowBindingUtil } from './bindings/arrow/ArrowBindingUtil'

/** @public */
export const defaultBindingUtils = [ArrowBindingUtil] as const
